import { useMemo } from "react";

type AnyObject = Record<string, any>;

export function useFilteredObject(obj: AnyObject): AnyObject {
  return useMemo(() => {
    const result: AnyObject = {};

    Object.entries(obj).forEach(([key, value]) => {
      const isEmpty =
        value === null ||
        value === undefined ||
        value === "" ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0);

      if (!isEmpty) {
        result[key] = value;
      }
    });

    return result;
  }, [obj]);
}
